import type { StripeAccountName } from '@inkitt/contracts-common';

export const FALLBACK_STRIPE_ACCOUNT_LOOKUP: Record<StripeAccountName, StripeAccountName> = {
  US: 'EU',
  EU: 'US',
};
